export interface IFrameDialog {
    url: string;
    width: string;
    height: string;
}
